import React from 'react';
import { MapCanvas } from './map/MapCanvas/MapCanvas';

export interface ViewCanvasProps {
  miniMapWidth?: number;
  miniMapHeight?: number;
}

export const ViewCanvas: React.FC<ViewCanvasProps> = ({
  miniMapWidth,
  miniMapHeight
}) => {
  return (
    <div className="map-editor-container absolute inset-0 z-0">
      <MapCanvas
        showOutside={true}
        miniMapHeight={miniMapHeight}
        miniMapWidth={miniMapWidth}
      />
    </div>
  );
};
